<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12">
    <g fill="currentColor" fill-rule="evenodd">
      <path
        d="m.837 5.038-.81-2.626a.692.692 0 0 1 .457-.847c.368-.1.752.1.87.445l.294.976A6.24 6.24 0 0 1 7 0c2.55 0 4.747 1.522 5.691 3.675.192.445-.147.947-.634.947a.681.681 0 0 1-.634-.402A4.8 4.8 0 0 0 7 1.35c-1.798 0-3.376.976-4.187 2.411l1.195-.344c.368-.1.752.1.87.445a.692.692 0 0 1-.458.847l-2.698.79a.725.725 0 0 1-.884-.46ZM12.647 9.976 12.352 9A6.221 6.221 0 0 1 7 12c-2.55 0-4.747-1.522-5.691-3.675-.192-.445.147-.947.634-.947.28 0 .531.158.634.402A4.8 4.8 0 0 0 7 10.65c1.798 0 3.376-.976 4.187-2.411l-1.194.345a.719.719 0 0 1-.87-.446.692.692 0 0 1 .457-.846l2.699-.79c.368-.1.752.1.87.46l.824 2.626a.692.692 0 0 1-.457.847c-.368.1-.766-.1-.87-.46Z"
      />
    </g>
  </svg>
</template>
